module.exports = __webpack_public_path__ + "static/TAS-11d8714b5859f62d39676b23619842ab.svg";